import React from 'react';
import '../../Styles/RightSideBar.css';
import { useTranslation } from 'react-i18next';
import FriendImage from '../../assets/friends-laughing-using-mobiles 2.png';
import SidebarPlayStoreImg from '../../assets/svg/sidebarPlayStore';

function RightSideBar() {
    const { t } = useTranslation();

    return (
        <div className="right-item-container">
            <div id="line"></div>

            <div className="right-content">
                <div className="restaurants-list">
                    <div className="app-download-container">
                        <p className="download-app-title">
                            {t('rightsidebar.download-app-title')}
                        </p>
                        <div className="app-badge-icon">
                            <SidebarPlayStoreImg/>
                        </div>

                        <img
                            src={FriendImage}
                            alt="laughing pic"
                            className="laughing-image"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RightSideBar;
